var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"best-value-ribbon"},[_c('BestValueRibbonIcon',{staticClass:"best-value-ribbon__icon"}),_c('span',[_vm._v("BEST VALUE")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }